export default "__VITE_ASSET__fd724ce3__"